import { createContext } from 'react';

import type { PictureInPictureContextValue } from './picture-in-picture-provider.types';

const noop = async () => {};

const defaultContextValue: PictureInPictureContextValue = {
  isPipSupported: false,
  isPipOpen: false,
  pipWindow: null,
  openPip: noop,
  closePip: () => {},
};

export const PictureInPictureContext =
  createContext<PictureInPictureContextValue>(defaultContextValue);
